import { cfg, getProfile } from './cfg.js';

/** Production deep-link apex (*.nwsl.ink). QA uses qa.nwsl.ink from profile cfg. */
export const DEEP_LINK_PRODUCTION_APEX = 'nwsl.ink';

function isLocalProfile() {
  return (getProfile() || 'local') === 'local';
}

export function getDeepLinkApexDomain() {
  const fromCfg = cfg?.deeplinkApi?.apexDomain;
  if (isLocalProfile()) {
    return String(fromCfg || 'localhost:3005').replace(/^\.+/, '').toLowerCase();
  }
  return String(fromCfg || DEEP_LINK_PRODUCTION_APEX).replace(/^\.+/, '').toLowerCase();
}

export function getDeepLinkScheme() {
  if (isLocalProfile()) {
    return cfg?.deeplinkApi?.scheme || 'http';
  }
  return 'https';
}

/** Public deep link: prod {subdomain}.nwsl.ink — QA {subdomain}.qa.nwsl.ink */
export function buildDeepLinkPublicUrl(subdomain, linkId, queryParams = null) {
  if (!subdomain || !linkId) {
    return '';
  }
  const apex = getDeepLinkApexDomain();
  const scheme = getDeepLinkScheme();
  const host = `${String(subdomain).toLowerCase()}.${apex}`;
  let url = `${scheme}://${host}/${encodeURIComponent(String(linkId))}`;
  if (queryParams && typeof queryParams === 'object') {
    const qs = new URLSearchParams();
    for (const [key, value] of Object.entries(queryParams)) {
      if (value != null && value !== '') {
        qs.set(key, String(value));
      }
    }
    const serialized = qs.toString();
    if (serialized) {
      url += `?${serialized}`;
    }
  }
  return url;
}
